<template>
  <!-- footer section -->
  <footer class="footer">
    <v-container>
      <v-row>
        <v-col>
          <p class="white--text">{{ $t("copyWrite") }}</p>
        </v-col>

        <v-col>
          <div class="socialIcons text-center">
            <p class="text-center social-title">
              {{ $t("Follow Us") }}
            </p>
            <a
              v-if="socialData.facebook_link"
              :href="socialData.facebook_link"
              target="_blank"
            >
              <i class="fab fa-facebook-f"></i>
            </a>
            <a
              v-if="socialData.linkedin_link"
              :href="socialData.linkedin_link"
              target="_blank"
            >
              <i class="fab fa-linkedin"></i>
            </a>
            <a
              v-if="socialData.twitter_link"
              :href="socialData.twitter_link"
              target="_blank"
            >
              <i class="fab fa-twitter"></i>
            </a>
            <a
              v-if="socialData.instagram_link"
              :href="socialData.instagram_link"
              target="_blank"
            >
              <i class="fab fa-instagram"></i>
            </a>
            <a
              v-if="socialData.snapchat_link"
              :href="socialData.snapchat_link"
              target="_blank"
            >
              <i class="fab fa-snapchat"></i>
            </a>
          </div>
        </v-col>

        <v-col>
          <ul class="list-unstyled">
            <li>{{ $t("contactUs") }}</li>
            <li>{{ $t("websitePolicy") }}</li>
            <li>{{ $t("userGuide") }}</li>
          </ul>
        </v-col>
      </v-row>
    </v-container>
  </footer>
</template>

<script>
export default {
  name: "sellerFooterComponent",
  data() {
    return {
      socialData: {}
    };
  },
  methods: {
    getSocialMediaLinks() {
      this.$http.get(this.getApiUrl + "/social_links").then(response => {
        if (response.data.status.error == false) {
          console.log(response.data);
          this.socialData = response.data.data;
        }
      });
    }
  },
  mounted() {
    this.getSocialMediaLinks();
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/_variables.scss";

.footer {
  background-color: $second-color !important;
  // margin-top: -24px;
  @media (min-width: 600px) {
    min-height: 100px;
  }
  img {
    max-width: 100% !important;
  }

  .list-unstyled {
    // margin-top: 1rem !important;
    color: #ffffff;
    text-align: center;
    list-style: none;
    li {
      display: inline-block;
      padding-left: 1rem;
      padding-right: 1rem;
    }
  }

  .socialIcons {
    .social-title {
      font-weight: bold;
      color: #ffffff;
      font-size: 1.5rem !important;
    }
    svg {
      font-size: 2rem !important;
      margin: 0 5px;
      color: #ffffff;
    }
  }
}
</style>
